//手机登录-验证码-用户选择的手机号码
export  const ContactwayCookieSpaceName = "COMMON_LOGIN_CONTACTWAY"
